import { createTheme } from './webapp-ui-theme';

export default createTheme({
  palette: {
    available: '#2980b9',
  },
});
